import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function StickyBottomCTA() {
  const checkoutUrl = 'https://ewordmedia.com/cart/48415277515004:1?checkout';
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-stone-200 shadow-lg" data-id="element-538">
      <div className="px-4 py-3" data-id="element-539">
        <a href={checkoutUrl} data-cta="sticky-bottom" onClick={() => {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'AddToCart');
        }
      }} className="block w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 focus:from-orange-600 focus:to-orange-700 focus:outline-none focus:ring-4 focus:ring-orange-300 text-white px-6 py-4 rounded-xl text-base font-bold transition-all duration-300 shadow-md" data-id="element-540">
          <span className="flex items-center justify-center gap-2" data-id="element-541">
            <span data-id="element-542">Only $17 Today — Instant Access</span>
            <ChevronRightIcon className="w-5 h-5" data-id="element-543" />
          </span>
        </a>
      </div>
    </div>;
}